const calcHasDailyBonusVisit = (): boolean => {
  const lastVisit = localStorage.getItem('dailyBonusLastVisitTime');
  let isVisit = !!lastVisit;

  if (lastVisit) {
    const now = new Date();
    const lastVisitDate = new Date(lastVisit);
    isVisit =
      now.getUTCFullYear() === lastVisitDate.getUTCFullYear() &&
      now.getUTCMonth() === lastVisitDate.getUTCMonth() &&
      now.getUTCDate() === lastVisitDate.getUTCDate();
  }

  return isVisit;
};

export { calcHasDailyBonusVisit };
